import { Stack } from '@mui/material'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'

import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { useGetMinutesFromSec } from 'utils/getMinutesFromSeconds/useGetMinutesFromSec'

export const FoodAvailabilityHeader = () => {
	const { statistics } = useWidgetStatistics()
	const seconds = statistics?.foodtable?.food_available_seconds
	const { value } = useGetMinutesFromSec(seconds || 0)
	const minutesTotal = Number(value) || 0
	const hours = Math.floor(minutesTotal / 60)
	const minutes = Math.floor(minutesTotal % 60)

	return (
		<Stack direction='column' gap='8px'>
			<TypographySecondary>Доступность корма</TypographySecondary>
			{seconds !== undefined ? (
				<Stack direction='row' gap='4px' alignItems='center'>
					<TypographyPrimary16Bold>{hours}</TypographyPrimary16Bold>
					<TypographyPrimary12>ч</TypographyPrimary12>
					{minutes > 0 && (
						<>
							<TypographyPrimary16Bold>{minutes}</TypographyPrimary16Bold>
							<TypographyPrimary12>мин</TypographyPrimary12>
						</>
					)}
				</Stack>
			) : (
				<TypographySecondary>Нет данных</TypographySecondary>
			)}
		</Stack>
	)
}
